const ITEMS = [
  "Pronto intervento H24",
  "Cancelli automatici",
  "Serrande elettriche",
  "Automazioni e motori",
  "Serrature e accessi",
  "Apertura porte",
  "Interventi elettrici urgenti",
  "Elettricista H24",
  "Roma e provincia",
];

export const Marquee = () => (
  <div
    data-testid="tech-marquee"
    className="border-y border-white/10 bg-[#0D1119] py-4"
  >
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-5 gap-y-1.5 px-4">
      {ITEMS.map((item) => (
        <span
          key={item}
          className="font-tech text-[10px] sm:text-xs font-medium uppercase tracking-[0.2em] text-zinc-500"
        >
          {item}
        </span>
      ))}
    </div>
  </div>
);
